module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAARCAYAAADdRIy+AAAACXBIWXMAABJ0AAASdAHeZh94AAABNUlEQVQ4ja3TPS9EURDG8d+9WS8FlUqjk3jpCJUPQIVColWI76ARhUqvlkhUIlbERiKIVhRIqESEQjRIFF53FffInmJ3EfskJzO5Z+5/5syZkwwuPUA/VtCCokxJ8Bex5JfKBTuI7ioxk9gPCSqphCu8xMCPGkmHcFJlLwnAM4ziNq0QVMQaDoKfoKHKygXbh5G4wlh7mAj+AMZD9p4ap4Bm+K4w7s9q5B9hNlQwjGXcVQGWYuBnsPfYrBD8ih1MoVd2UVt4imI+IQlj04FOPOI0SlRJ78q97UJ7+H6J6xwWMIa3AGquAYtVCv98n64R+Rxm0PZLyE9qTWUzVC+dp8jXEbiRYlfW6P/qGYUUFzivA/AQ16nslrbrAMxTnrf1f8JeUKD8lo8xj2k0/QGUyF7LHG7gC1krQnpNYYRtAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/基础档案B.png
// module id = S5qz
// module chunks = 2